import clsx from "clsx";

import type { BoxProps } from "@/ui/atoms/Box";
import Box from "@/ui/atoms/Box";

export type BlockProps = BoxProps;

const testId = "Block";
const Block = (props: BlockProps) => {
    const {
        sx,
        children,
        className,
        height,
        width,
        minHeight,
        minWidth,
        padding,
        ...otherProps
    } = props;

    return (
        <Box
            data-testid={testId}
            className={clsx([testId, className])}
            sx={{
                minWidth: minWidth,
                minHeight: minHeight,
                height: height ?? "100%",
                width: width ?? "100%",
                padding: padding,
                display: "grid",
                placeItems: "center",
                boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.2)",
                borderRadius: "10px",
                backgroundColor: "var(--proda-white)",
                ...sx,
            }}
            {...otherProps}
        >
            {children}
        </Box>
    );
};

export default Block;
